import { createContext } from 'react'
const FirebaseContext = createContext(null)

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
}

const firebase = window.firebase.initializeApp(config)

const FirebaseContextProvider = ({ children }) => {
  return <FirebaseContext.Provider value={{ firebase }}>{children}</FirebaseContext.Provider>
}

export { FirebaseContextProvider, FirebaseContext }
